// ⚠️ Auto-generated from config_stage.yml
export const environment = {
  "production": false,
  "AppName": "MeXeM",
  "ApiBaseUrl": "https://iba-api-stage.azurewebsites.net/",
  "ApiPrefix": "api/",
  "Crypto": {
    "Password": "EF737CC29DAE7C80644A5B01544CBA61",
    "Salt": "12345678",
    "KeyIV": "79994A6EF73DA76C"
  },
  "Recaptcha": {
    "SiteKey": "6LdR2sYfAAAAAM8cJ28k0lPrmwgfAR67z8TCDCd_",
    "BaseUrl": "https://www.google.com/recaptcha/api.js"
  }
};
